/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 管理员搜索
 */
import styles from './searchForm.scss';
// import classNames from 'classnames';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { Form, Input } from 'antd';
const FormItem = Form.Item;

class SearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.onSubmit();
    }

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values);
            }
        });
    };

    render() {
        const { handleCreate } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="search-bar">
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <FormItem>
                        {getFieldDecorator('name', {
                            initialValue: ''
                        })(
                            <Input placeholder="请输入姓名/账号/部门" className={styles.keywordInput}/>
                        )}
                    </FormItem>
                    <FormItem>
                        <button type="submit" className="btn btn-blue">搜索</button>
                    </FormItem>
                    <FormItem>
                        <button type="button" className="btn btn-orange" onClick={handleCreate}>新建</button>
                    </FormItem>
                    <Link className="btn btn-gray fr" to="/grzx">返回个人中心</Link>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/admin/index/SearchForm.jsx